import React, {FC} from 'react';
import {IWifiAnalyzerResults} from '../../services/AngularServices/WifiAnalyzerService';
import {getWifiAnalyzerScanRecordId} from '../right-bar/wifi-scan-history.utils';
import './styles.scss';
import WifiFindOutlined from '../../../../img/wifi/WifiFindOutlined.png';

interface IWifiScanHistoryButton {
    onClickWifiScanHistoryButton: (wifiScanId: string) => void;
    wifiScanData: IWifiAnalyzerResults;
    ssidImage?: string;
}

function formatCreatedOn(dateInput: string | Date): string {
    const date = new Date(dateInput);

    const options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };

    const formatted = date.toLocaleString('en-US', options);

    return formatted;
}

export const VisualScanHistoryButton: FC<IWifiScanHistoryButton> = ({
    wifiScanData,
    onClickWifiScanHistoryButton,
    ssidImage
}) => {
    const createdOnFormatted = formatCreatedOn(wifiScanData.createdOn);
    const displayImage = ssidImage || WifiFindOutlined;

    return (
        wifiScanData && (
            <div className='centered-column'>
                <div className='scan-visual-history-date'>{createdOnFormatted}</div>
                <button
                    className='scan-visual-history-btn-container'
                    onClick={() =>
                        onClickWifiScanHistoryButton(
                            getWifiAnalyzerScanRecordId(wifiScanData) ||
                                String(wifiScanData._id ?? wifiScanData.id ?? '')
                        )
                    }
                    type='button'>
                    <img src={displayImage} alt='Visual scan icon' />
                </button>
            </div>
        )
    );
};
